import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormInputComponent } from '../ndd-ng-form-input/ndd-ng-form-input.component';

@Component({
    selector: 'ndd-ng-form-password',
    template: require('./ndd-ng-form-password.component.html'),
})
export class NDDFormPasswordComponent extends NDDFormInputComponent implements OnInit {
    /** Mascara que substitui o valor da senha */
    @Input() public controlMask?: string = '******';
    /** Informa se o password original existe */
    @Input() public controlPasswordExists?: boolean = false;

    /** Evento de alteração do password. */
    @Output() public controlPasswordChange: EventEmitter<null> = new EventEmitter();

    /** Identifica quando o password foi alterado pelo usuário */
    private passwordChanged: boolean = false;

    constructor(formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        super.ngOnInit();

        if (this.controlPasswordExists) {
            this.control.setValue(this.controlMask);
        }
    }

    public focusin(): void {
        if (!this.passwordChanged) {
            this.control.setValue('');
        }

        this.passwordChanged = true;
        this.controlPasswordChange.emit();

        super.focusin();
    }
}
